import axios from "@/axios";

export default {
  namespaced: true,
  state: {
    loading: false,
    policies: [],
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    policies(state) {
      return state.policies;
    },
  },
  mutations: {
    RESET(state) {
      state.loading = false;
      state.policies = [];
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_POLICIES(state, payload) {
      state.policies = payload;
    },
  },
  actions: {
    reset({ commit }) {
      commit("RESET");
    },
    fetchPolicies({ commit }, payload = {}) {
      commit("SET_LOADING", true);

      let url = "/booking_policies?";
      if ("pagination" in payload) url += `pagination=${payload.pagination}`;

      return new Promise((resolve, reject) => {
        axios
          .get(url)
          .then((response) => {
            commit("SET_POLICIES", response.data["hydra:member"]);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
            // TODO: log error to Sentry
          })
          .finally(() => commit("SET_LOADING", false));
      });
    },
  },
};
